import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import IconSuccess from '../components/InspectionCheckList/images/IconSuccess.svg';

const inspectionPointsHelper = {
  getPageHeaderProps(dataFormatted, assets, navigations, entries) {
    const { fields } = (dataFormatted.component_PageHeader || [])[0] || {};
    if (!fields) {
      return {};
    }
    const img = this.findResource(((fields.image || {}).sys || {}).id, assets);

    const benefits = [
      {
        id: 1,
        logo: 'https://images.ctfassets.net/r0of6sld2ads/ak2oaNQCR2kO03i9pzKNu/d87283884a8fb8063f622c03d54f5807/icon.svg',
        title: 'No stone unturned',
        smallTitle: '',
        bodyText: `A checklist developed by experts. Every car is rigorously tested against our comprehensive, custom checklist, developed by industry experts with decades of experience at leading car manufacturers.`,
      },
      {
        id: 2,
        logo: 'https://images.ctfassets.net/r0of6sld2ads/4YeOUk2IXAfHSEuQEPvCl6/9d539088282e1b7964a757392c050f72/icon.svg',
        title: 'A scientific approach to inspection',
        smallTitle: '',
        bodyText: `Our state-of-the-art test facility. All cars are examined and rigorously tested at our purpose-built 30,000 sqm facility. Its advanced diagnostics equipment includes laser-wheel alignment and precision-engineered suspension and brake test lanes. For the best performance, we only use Mobil oils.`,
      },
      {
        id: 3,
        logo: 'https://images.ctfassets.net/r0of6sld2ads/71RU9T6kGBlUB7lEIbvVW8/5d38c16c8328e8f1972bfafcc92a21d9/icon.svg',
        title: 'Issues identified and resolved',
        smallTitle: '',
        bodyText: `A dedicated professional team. Our fully certified team have the mechanical and technical skills needed to identify and resolve a wide range of potential issues, across all makes and models.`,
      },
    ];

    return {
      img: this.getImageUrl(img),
      headline: fields.title,
      mainText: documentToReactComponents(fields.subHead),
      benefitList: benefits,
    };
  },

  getInspectionChecklistProps(dataFormatted, assets, navigations, entries) {
    const { fields } = (dataFormatted.component_PointInspection || [])[0] || {};
    if (!fields) {
      return {};
    }

    const inspectionsResource = fields.allInspections.map((inspection) =>
      this.findResource(inspection.sys.id, entries),
    );

    const questions = [];

    inspectionsResource.forEach((resource) => {
      if (resource && !questions.find((item) => item.question === resource.fields.category)) {
        questions.push({
          icon: this.getImageUrl(this.findResource(((resource.fields.icon || {}).sys || {}).id, assets)),
          question: resource.fields.category,
          listDataChildren: [],
        });
      }
    });

    fields.allInspections.forEach((inspection, index) => {
      const resource = this.findResource(inspection.sys.id, entries);
      if (resource) {
        questions.forEach((item) => {
          if (item.question === resource.fields.category) {
            item.listDataChildren.push({
              answer: resource.fields.name,
              checkAnswer: '',
              iconSuccess: IconSuccess,
            });
          }
        });
      }
    });

    return {
      title: fields.headline,
      data: questions,
    };
  },

  getFooterProps(dataFormatted, assets, navigations) {
    const { fields } = (dataFormatted?.sharedFooterComponent || [])[0] || {};

    if (!fields) {
      return {};
    }

    const items = [
      { header: 'popularModelsLinkBlockHeader', links: 'popularModelsLinkBlock' },
      { header: 'popularCarTypesBlockLinkHeader', links: 'popularCarTypesLinkBlock' },
      { header: 'aboutUsLinkBlockHeader', links: 'aboutUsLinkBlock' },
      { header: 'supportHeader', links: 'supportLinkBlock' },
      { header: 'followUsLinkBlockHeader', links: 'followUsBlockLink' },
    ].map((item) => {
      const children = (fields[item.links] || [])
        .map((link) => {
          const nav = this.findResource(link.sys.id, navigations);
          if (!nav) {
            return null;
          }

          return {
            label: nav.fields.text,
            href: nav.fields.link || '#',
          };
        })
        .filter((v) => v);

      return {
        label: fields[item.header],
        children,
      };
    });

    const privary = this.findResource(((fields.privaryPolicy || {}).sys || {}).id, navigations);
    const term = this.findResource(((fields.termsAndConditions || {}).sys || {}).id, navigations);
    const iconSupport = this.getImageUrl(this.findResource(fields.supportIconButton?.sys?.id, assets));

    return {
      copyright: fields.copyrightText,
      licences: documentToReactComponents(fields.description),
      supportContent: {
        title: fields.supportTitle,
        description: fields.supportWorkingTime,
        button: {
          label: fields.supportTextButton,
          icon: iconSupport ? <img src={iconSupport} alt={fields.supportTextButton} /> : null,
        },
        helpModalProps: {
          content: documentToReactComponents(fields.helpModalContent),
        },
      },
      items,
      term: {
        label: privary ? term.fields.text : '',
        href: privary ? term.fields.link : '',
      },
      policy: {
        label: privary ? privary.fields.text : '',
        href: privary ? privary.fields.link : '',
      },
    };
  },

  findResource(id, resources = []) {
    return resources.find((asset) => asset.sys.id === id);
  },

  getImageUrl(asset) {
    return asset ? asset.fields.file.url : null;
  },
};

export default inspectionPointsHelper;
